/**
 * A group membership label.
 *
 * Renders group membership strings from the backend without validation.
 * @module components/Badge/Badge
 */
import React from 'react';

import './Badge.scss';

interface BadgeProps {
  /** The badge's title, which is also its identity on the backend. */
  title: string;
}

const Badge: React.FC<BadgeProps> = ({ title }) => {
  return <span className="badge">{title}</span>;
};

export default Badge;
